import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SplashPage.css';
import SEO from '../../Components/SEO/SEO';

// SVG Icons for Header, Features, and Footer to ensure high-fidelity without external asset issues.
const Icons = {
  logo: (
    <svg className="h-icon" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 2C10.0589 2 2 10.0589 2 20C2 29.9411 10.0589 38 20 38C29.9411 38 38 29.9411 38 20C38 10.0589 29.9411 2 20 2ZM20 34C12.268 34 6 27.732 6 20C6 12.268 12.268 6 20 6C27.732 6 34 12.268 34 20C34 27.732 27.732 34 20 34Z" fill="currentColor" />
      <path d="M20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30C25.5228 30 30 25.5228 30 20C30 14.4772 25.5228 10 20 10ZM20 26C16.6863 26 14 23.3137 14 20C14 16.6863 16.6863 14 20 14C23.3137 14 26 16.6863 26 20C26 23.3137 23.3137 26 20 26Z" fill="currentColor" />
    </svg>
  ),
  search: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  ),
  hamburger: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="3" y1="12" x2="21" y2="12"></line>
      <line x1="3" y1="6" x2="21" y2="6"></line>
      <line x1="3" y1="18" x2="21" y2="18"></line>
    </svg>
  ),
  // Card 1 Features
  vote: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
      <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </svg>
  ),
  discuss: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
    </svg>
  ),
  campaign: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
      <line x1="4" y1="22" x2="4" y2="15"></line>
    </svg>
  ),
  career: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
    </svg>
  ),
  dating: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
    </svg>
  ),
  ai: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
      <path d="M12 2v9M8 5h8M8 8h8M3 16h18"></path>
    </svg>
  ),
  certification: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
      <path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5"></path>
    </svg>
  ),
  funding: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="1" x2="12" y2="23"></line>
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
    </svg>
  ),
  marketplace: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
      <line x1="3" y1="6" x2="21" y2="6"></line>
      <path d="M16 10a4 4 0 0 1-8 0"></path>
    </svg>
  ),
  monetize: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
      <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
    </svg>
  ),
  donate: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
    </svg>
  ),
  // Card 2 Features
  knowledge: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
    </svg>
  ),
  duties: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="16" y1="13" x2="8" y2="13"></line>
      <line x1="16" y1="17" x2="8" y2="17"></line>
      <polyline points="10 9 9 9 8 9"></polyline>
    </svg>
  ),
  amalgamator: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
    </svg>
  ),
  shield: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    </svg>
  ),
  overseer: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
      <circle cx="12" cy="12" r="3"></circle>
    </svg>
  ),
  event: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="16" y1="2" x2="16" y2="6"></line>
      <line x1="8" y1="2" x2="8" y2="6"></line>
      <line x1="3" y1="10" x2="21" y2="10"></line>
    </svg>
  ),
  community: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
  ),
  connections: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
    </svg>
  ),
  share: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="18" cy="5" r="3"></circle>
      <circle cx="6" cy="12" r="3"></circle>
      <circle cx="18" cy="19" r="3"></circle>
      <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
      <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
    </svg>
  ),
  explore: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>
    </svg>
  ),
  places: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
      <circle cx="12" cy="10" r="3"></circle>
    </svg>
  ),
  bookings: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2"></rect>
      <path d="M9 17h6M9 13h6M9 9h6"></path>
    </svg>
  ),
  // Card 3 Features
  shop: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="21" r="1"></circle>
      <circle cx="20" cy="21" r="1"></circle>
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
    </svg>
  ),
  categories: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7"></rect>
      <rect x="14" y="3" width="7" height="7"></rect>
      <rect x="14" y="14" width="7" height="7"></rect>
      <rect x="3" y="14" width="7" height="7"></rect>
    </svg>
  ),
  dealers: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
      <polyline points="2 17 12 22 22 17"></polyline>
      <polyline points="2 12 12 17 22 12"></polyline>
    </svg>
  ),
  services: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
    </svg>
  ),
  orders: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="16" y1="13" x2="8" y2="13"></line>
      <line x1="16" y1="17" x2="8" y2="17"></line>
      <polyline points="10 9 9 9 8 9"></polyline>
    </svg>
  ),
  reviews: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
    </svg>
  ),
  // Footer Icons
  secure: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
      <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
    </svg>
  ),
  wallet: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="4" width="20" height="16" rx="2"></rect>
      <line x1="12" y1="4" x2="12" y2="20"></line>
    </svg>
  ),
  notifications: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
    </svg>
  ),
  messages: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
    </svg>
  ),
  saved: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
    </svg>
  ),
  profile: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
      <circle cx="12" cy="7" r="4"></circle>
    </svg>
  ),
  mate: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="16" x2="12" y2="12"></line>
      <line x1="12" y1="8" x2="12.01" y2="8"></line>
    </svg>
  )
};

export default function SplashPage() {
  const navigate = useNavigate();

  return (
    <>
      <SEO
        title="Amalgamate · Educate · Facilitate"
        description="Connect & Decide with AmalgaMate; Learn & Certify with Educate; and Buy, Sell & Earn with Facilitate."
        image="/Assets/SplashPage/splash_bg.png"
        slugPath="/"
      />
      <div className="splash-root-v2">
        {/* Deep SpaceConstellation Background elements */}
        <div className="space-overlay"></div>
        <div className="constellation-bg"></div>

        {/* HEADER SECTION */}
        <header className="sp-header">
          <div className="sp-logo" onClick={() => navigate('/')}>
            <img
              src="/Assets/Donation/DonationHeader/amalgamateLogoo.svg"
              alt="AmalgaMate"
              className="sp-logo-img"
            />
          </div>

          <nav className="sp-nav">
            <span className="sp-nav-link active-link" onClick={() => navigate('/amalgamate')}>AMALGAMATE</span>
            <span className="sp-nav-link" onClick={() => navigate('/educate')}>EDUCATE</span>
            <span className="sp-nav-link" onClick={() => navigate('/facilitate')}>FACILITATE</span>
          </nav>

          <div className="sp-header-actions">
            <button className="sp-btn-get" onClick={() => navigate('/amalgamate')}>Get The App</button>
            <button className="sp-btn-login" onClick={() => navigate('/login')}>Login</button>
          </div>
        </header>

        {/* CORE HERO TITLE */}
        <section className="sp-hero-title">
          <div className="sp-hero-capsule">
            <h1 className="sp-hero-heading">
              <span className="sp-pillar sp-pillar-amalgamate">AMALGAMATE</span>
              <span className="sp-pillar-dot">·</span>
              <span className="sp-pillar sp-pillar-educate">EDUCATE</span>
              <span className="sp-pillar-dot">·</span>
              <span className="sp-pillar sp-pillar-facilitate">FACILITATE</span>
            </h1>
            <p className="sp-hero-subheading">
              <span className="sp-sub-item sp-sub-amalgamate">Connect &amp; Decide</span>
              <span className="sp-sub-dot">·</span>
              <span className="sp-sub-item sp-sub-educate">Learn &amp; Certify</span>
              <span className="sp-sub-dot">·</span>
              <span className="sp-sub-item sp-sub-facilitate">Buy, Sell &amp; Earn</span>
            </p>
          </div>
        </section>

        {/* THREE GLOWING CARDS CONTAINER */}
        <main className="sp-cards-container">
          {/* CARD 1: AMALGAMATE */}
          <section className="sp-glow-card card-amalgamate">
            <div className="card-header-block">
              <span className="card-step-badge">STEP 01 · CONNECT & DECIDE</span>
              <div className="card-brand">
                <img src="/Assets/Header/amalgamateLogo.svg" alt="AmalgaMate" className="card-logo-img" />
                <div className="card-logo-text">
                  <span className="card-logo-title">AMALGAMATE</span>
                </div>
              </div>
              <p className="card-desc">Amalgamate brings people, ideas, resources, and civic decisions together.</p>
            </div>

            <div className="card-body-split">
              <div className="card-left-column">
                <ul className="card-features-list">
                  <li>
                    <span className="feat-icon-badge">{Icons.vote}</span>
                    <div className="feat-text">
                      <strong>Ballots - Decisions - Solutions</strong>
                      <span>Collective intelligence is the future.</span>
                    </div>
                  </li>
                  <li>
                    <span className="feat-icon-badge">{Icons.discuss}</span>
                    <div className="feat-text">
                      <strong>Public Discussions</strong>
                      <span>Transparent debates.</span>
                    </div>
                  </li>
                  <li>
                    <span className="feat-icon-badge">{Icons.campaign}</span>
                    <div className="feat-text">
                      <strong>Causes & Campaigns</strong>
                      <span>Champion community initiatives.</span>
                    </div>
                  </li>
                  <li>
                    <span className="feat-icon-badge">{Icons.community}</span>
                    <div className="feat-text">
                      <strong>Groups & Communities</strong>
                      <span>Spaces aligned with your expertise.</span>
                    </div>
                  </li>
                  <li className="feat-item-upcoming">
                    <span className="feat-icon-badge">{Icons.career}</span>
                    <div className="feat-text">
                      <div className="feat-title-row">
                        <strong>Career & Opportunities</strong>
                        <span className="coming-soon-pill">Coming Soon</span>
                      </div>
                      <span>Professional networking & jobs.</span>
                    </div>
                  </li>
                  <li className="feat-item-upcoming">
                    <span className="feat-icon-badge">{Icons.dating}</span>
                    <div className="feat-text">
                      <div className="feat-title-row">
                        <strong>Dating & Friendship</strong>
                        <span className="coming-soon-pill">Coming Soon</span>
                      </div>
                      <span>Build authentic personal connections.</span>
                    </div>
                  </li>
                </ul>
              </div>

              {/* HIGH FIDELITY PHONE MOCKUP */}
              <div className="phone-mockup-wrapper">
                <div className="phone-mockup phone-mockup--amalgamate">
                  <div className="phone-dynamic-island"></div>
                  <div className="phone-screen phone-screen-amalgamate">
                    <div className="phone-status-bar">
                      <span>9:41</span>
                      <div className="phone-status-icons">📶 🔋</div>
                    </div>
                    <div className="phone-app-header">
                      <div className="phone-header-brand">
                        <img src="/Assets/Header/amalgamateLogo.svg" alt="Logo" className="mini-logo" />
                        <span>AmalgaMate</span>
                      </div>
                      <span className="phone-badge-pulse">● Live</span>
                    </div>

                    <div className="phone-ballot-preview">
                      <div className="phone-ballot-tag">Ballot #BL-2026-041</div>
                      <h5>Should Canada strengthen border and resource protection?</h5>
                      <div className="phone-vote-track">
                        <div className="phone-vote-bar" style={{ width: '78%' }}></div>
                      </div>
                      <div className="phone-vote-stats">
                        <span className="vote-pct">78% Yes</span>
                        <span className="vote-cnt">18,420 votes</span>
                      </div>
                      <button className="phone-btn-vote">Cast Your Ballot 🗳️</button>
                    </div>

                    <div className="phone-pulse-box">
                      <div className="phone-pulse-row">
                        <span>💬 Transit Route</span>
                        <strong>84% Yes</strong>
                      </div>
                      <div className="phone-pulse-row">
                        <span>💧 Clean Water</span>
                        <span className="pulse-tag-green">Funded</span>
                      </div>
                      <div className="phone-pulse-row">
                        <span>🏥 Health Clinic</span>
                        <strong>91% Yes</strong>
                      </div>
                    </div>

                    <div className="phone-list-pills">
                      <span>💧 Water</span>
                      <span>🏥 Health</span>
                      <span>🚌 Transit</span>
                    </div>

                    <div className="phone-amalgamate-footer">
                      <span>🔒 100% On-Chain Quorum</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <button className="card-action-btn btn-amalgamate" onClick={() => navigate('/amalgamate')}>
              Join AmalgaMate <span>→</span>
            </button>
          </section>

          {/* CARD 2: EDUCATE */}
          <section className="sp-glow-card card-adventure">
            <div className="card-header-block">
              <span className="card-step-badge">STEP 02 · LEARN & CERTIFY</span>
              <div className="card-brand">
                <div className="card-logo-icon green-icon">🎓</div>
                <div className="card-logo-text">
                  <span className="card-logo-title green-title">EDUCATE</span>
                </div>
              </div>
              <p className="card-desc">Our mission is to be a place where the truth can be found. Free universal knowledge.</p>
            </div>

            <div className="card-body-split">
              <div className="card-left-column">
                <ul className="card-features-list">
                  <li>
                    <span className="feat-icon-badge">{Icons.certification}</span>
                    <div className="feat-text">
                      <strong>Teachings & Certifications</strong>
                      <span>Design modules & certify capability.</span>
                    </div>
                  </li>
                  <li>
                    <span className="feat-icon-badge">{Icons.knowledge}</span>
                    <div className="feat-text">
                      <strong>Universal Knowledge Base</strong>
                      <span>Decentralized encyclopedia of truth.</span>
                    </div>
                  </li>
                  <li>
                    <span className="feat-icon-badge">{Icons.amalgamator}</span>
                    <div className="feat-text">
                      <strong>Certified Amalgamator</strong>
                      <span>Master consensus & governance.</span>
                    </div>
                  </li>
                  <li>
                    <span className="feat-icon-badge">{Icons.duties}</span>
                    <div className="feat-text">
                      <strong>Human Rights & Responsibilities</strong>
                      <span>Philosophical foundations of self-rule.</span>
                    </div>
                  </li>
                  <li>
                    <span className="feat-icon-badge">{Icons.shield}</span>
                    <div className="feat-text">
                      <strong>Certified Protector</strong>
                      <span>De-escalation & neighborhood security.</span>
                    </div>
                  </li>
                  <li>
                    <span className="feat-icon-badge">{Icons.overseer}</span>
                    <div className="feat-text">
                      <strong>Certified Overseer</strong>
                      <span>Audit public ledgers & disbursements.</span>
                    </div>
                  </li>
                </ul>
              </div>

              {/* HIGH FIDELITY PHONE MOCKUP */}
              <div className="phone-mockup-wrapper">
                <div className="phone-mockup phone-mockup--educate">
                  <div className="phone-dynamic-island"></div>
                  <div className="phone-screen phone-screen-adventure">
                    <div className="phone-status-bar">
                      <span>9:41</span>
                      <div className="phone-status-icons">📶 🔋</div>
                    </div>
                    <div className="phone-app-header">
                      <div className="phone-header-brand">
                        <span>🎓</span>
                        <span>Educate</span>
                      </div>
                      <span className="phone-badge-verified">✓ Verified</span>
                    </div>

                    <div className="phone-educate-hero">
                      <span className="phone-cert-eyebrow">📜 Foundation Accord</span>
                      <h5 className="phone-cert-title">The Foundation of Life as a Human</h5>
                    </div>

                    <div className="phone-tenets-container">
                      <div className="phone-tenet-item">
                        <span className="phone-tenet-num">1</span>
                        <div>
                          <strong>Planet Earth is #1</strong>
                          <span>The planet earth is the most important thing in existence.</span>
                        </div>
                      </div>
                      <div className="phone-tenet-item">
                        <span className="phone-tenet-num">2</span>
                        <div>
                          <strong>Human Life is #2</strong>
                          <span>Human life is the 2nd most important thing in existence.</span>
                        </div>
                      </div>
                      <div className="phone-tenet-item">
                        <span className="phone-tenet-num">3</span>
                        <div>
                          <strong>Non-Harm Principle</strong>
                          <span>No person is allowed to harm another.</span>
                        </div>
                      </div>
                      <div className="phone-tenet-item">
                        <span className="phone-tenet-num">4</span>
                        <div>
                          <strong>Victim Restitution</strong>
                          <span>If one harms another, the person harmed gets the right to ensure the person that harmed them never does it again. The choice is theirs how they insure it.</span>
                        </div>
                      </div>
                      <div className="phone-tenet-item">
                        <span className="phone-tenet-num">5</span>
                        <div>
                          <strong>Mutual Protection</strong>
                          <span>All humans have the right to protect any person that asks for protection.</span>
                        </div>
                      </div>
                      <div className="phone-tenet-item">
                        <span className="phone-tenet-num">6</span>
                        <div>
                          <strong>Right to Peace</strong>
                          <span>All humans have a right to live in peace. Lack of peace is harm.</span>
                        </div>
                      </div>
                    </div>

                    <div className="phone-cert-footer">
                      <span>🛡️ Ledger Audited Proof</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <button className="card-action-btn btn-adventure" onClick={() => navigate('/educate')}>
              Explore Educate <span>→</span>
            </button>
          </section>

          {/* CARD 3: FACILITATE */}
          <section className="sp-glow-card card-gear">
            <div className="card-header-block">
              <span className="card-step-badge">STEP 03 · BUY, SELL & EARN</span>
              <div className="card-brand">
                <div className="card-logo-icon green-icon">⚙️</div>
                <div className="card-logo-text">
                  <span className="card-logo-title green-title">FACILITATE</span>
                </div>
              </div>
              <p className="card-desc">The marketplace of the future—self-governance funded by the people, for the people.</p>
            </div>

            <div className="card-body-split">
              <div className="card-left-column">
                <ul className="card-features-list">
                  <li>
                    <span className="feat-icon-badge">{Icons.shop}</span>
                    <div className="feat-text"><strong>Buy & Sell Goods</strong><span>Decentralized peer commerce.</span></div>
                  </li>
                  <li>
                    <span className="feat-icon-badge">{Icons.services}</span>
                    <div className="feat-text"><strong>Hire & Offer Services</strong><span>Book local verified experts.</span></div>
                  </li>
                  <li>
                    <span className="feat-icon-badge">{Icons.event}</span>
                    <div className="feat-text"><strong>Events & Ticketing</strong><span>Host & join community gatherings.</span></div>
                  </li>
                  <li>
                    <span className="feat-icon-badge">{Icons.monetize}</span>
                    <div className="feat-text"><strong>Secure Payouts</strong><span>Onboard Stripe with safe escrow.</span></div>
                  </li>
                  <li>
                    <span className="feat-icon-badge">{Icons.bookings}</span>
                    <div className="feat-text"><strong>Order Management</strong><span>Track bookings, quotes & shipments.</span></div>
                  </li>
                  <li>
                    <span className="feat-icon-badge">{Icons.funding}</span>
                    <div className="feat-text"><strong>Civic Facilitations</strong><span>Direct fund disbursements for solutions.</span></div>
                  </li>
                </ul>
              </div>

              {/* HIGH FIDELITY PHONE MOCKUP */}
              <div className="phone-mockup-wrapper">
                <div className="phone-mockup phone-mockup--gear">
                  <div className="phone-dynamic-island"></div>
                  <div className="phone-screen phone-screen-gear">
                    <div className="phone-status-bar">
                      <span>9:41</span>
                      <div className="phone-status-icons">📶 🔋</div>
                    </div>
                    <div className="phone-app-header">
                      <div className="phone-header-brand">
                        <span>⚙️</span>
                        <span>Facilitate</span>
                      </div>
                      <span className="phone-badge-escrow">100% Escrow</span>
                    </div>

                    <div className="phone-cause-header">
                      <span className="phone-cause-label">Funds Facilitated</span>
                      <h6 className="phone-cause-name">Elders in Need · BC</h6>
                      <div className="phone-cause-total">$347,800</div>
                    </div>

                    <div className="phone-bc-chart">
                      <div className="phone-bc-hdr">
                        <span>City (BC)</span>
                        <span>Disbursed</span>
                      </div>

                      <div className="phone-bc-row">
                        <div className="phone-bc-info">
                          <span className="phone-bc-city">Vancouver</span>
                          <span className="phone-bc-val">$142,500</span>
                        </div>
                        <div className="phone-bc-bar-bg">
                          <div className="phone-bc-bar-fill" style={{ width: '85%' }}></div>
                        </div>
                      </div>

                      <div className="phone-bc-row">
                        <div className="phone-bc-info">
                          <span className="phone-bc-city">Victoria</span>
                          <span className="phone-bc-val">$88,200</span>
                        </div>
                        <div className="phone-bc-bar-bg">
                          <div className="phone-bc-bar-fill" style={{ width: '55%' }}></div>
                        </div>
                      </div>

                      <div className="phone-bc-row">
                        <div className="phone-bc-info">
                          <span className="phone-bc-city">Kelowna</span>
                          <span className="phone-bc-val">$64,000</span>
                        </div>
                        <div className="phone-bc-bar-bg">
                          <div className="phone-bc-bar-fill" style={{ width: '40%' }}></div>
                        </div>
                      </div>

                      <div className="phone-bc-row">
                        <div className="phone-bc-info">
                          <span className="phone-bc-city">Surrey</span>
                          <span className="phone-bc-val">$53,100</span>
                        </div>
                        <div className="phone-bc-bar-bg">
                          <div className="phone-bc-bar-fill" style={{ width: '32%' }}></div>
                        </div>
                      </div>
                    </div>

                    <div className="phone-escrow-meta">
                      <span>🛡️ 1,280 Orders Escrow Protected</span>
                    </div>

                    <div className="phone-bc-footer">
                      <span>✔️ Public Ledger Audited</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <button className="card-action-btn btn-gear" onClick={() => navigate('/facilitate')}>
              Explore Facilitate <span>→</span>
            </button>
          </section>
        </main>

        {/* FOOTER NAVIGATION */}
        <footer className="sp-footer-v2">
          <div className="sp-footer-hdr">
            <span className="sp-footer-tag">ONE ACCOUNT ACCESS</span>
          </div>
          <div className="sp-footer-links">
            <span className="sp-footer-plain-text">Verified Identity</span>
            <span className="sp-footer-plain-text">Active Ballots</span>
            <span className="sp-footer-plain-text">My Certificates</span>
            <span className="sp-footer-plain-text">Civic Circles</span>
            <span className="sp-footer-plain-text">Escrow Wallet</span>
          </div>

          <div className="sp-footer-legal-divider"></div>

          <div className="sp-footer-legal-row">
            <span className="sp-footer-copyright">
              © {new Date().getFullYear()} AmalgaMate Unification Services LTD. All rights reserved.
            </span>
            <div className="sp-footer-legal-links">
              <span className="sp-legal-link" onClick={() => navigate('/privacy-policy')}>
                Privacy Policy
              </span>
              <span className="sp-legal-separator">•</span>
              <span className="sp-legal-link" onClick={() => navigate('/terms-of-use')}>
                Terms of Use
              </span>
              <span className="sp-legal-separator">•</span>
              <span className="sp-legal-link" onClick={() => navigate('/donate/voting-rules')}>
                Voting Rules
              </span>
              <span className="sp-legal-separator">•</span>
              <span className="sp-legal-link" onClick={() => navigate('/amalgamate#about')}>
                About
              </span>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}
